// extracted by mini-css-extract-plugin
export var wrapper = "Certificates-module--wrapper--61340";
export var certificate = "Certificates-module--certificate--a7e02";